export default __webpack_public_path__ + "static/javascript_fullstack_bootcamp-13-b1db490182864cb84ee38e8afc87c343.jpg";